import { render, staticRenderFns } from "./GeneralInfoDefault.vue?vue&type=template&id=7b07b0de&scoped=true&"
import script from "./GeneralInfoDefault.vue?vue&type=script&lang=ts&"
export * from "./GeneralInfoDefault.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInfoDefault.vue?vue&type=style&index=0&id=7b07b0de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07b0de",
  null
  
)

export default component.exports